/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request model for users changing their own password.
 * @export
 * @interface PasswordChange
 */
export interface PasswordChange {
    /**
     * Current password for verification
     * @type {string}
     * @memberof PasswordChange
     */
    old_password: string;
    /**
     * New password to set
     * @type {string}
     * @memberof PasswordChange
     */
    new_password: string;
    /**
     * Whether to log out from all devices after password change
     * @type {boolean}
     * @memberof PasswordChange
     */
    logout_all_devices?: boolean;
}

/**
 * Check if a given object implements the PasswordChange interface.
 */
export function instanceOfPasswordChange(value: object): value is PasswordChange {
    if (!('old_password' in value) || value['old_password'] === undefined) return false;
    if (!('new_password' in value) || value['new_password'] === undefined) return false;
    return true;
}

export function PasswordChangeFromJSON(json: any): PasswordChange {
    return PasswordChangeFromJSONTyped(json, false);
}

export function PasswordChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordChange {
    if (json == null) {
        return json;
    }
    return {
        
        'old_password': json['old_password'],
        'new_password': json['new_password'],
        'logout_all_devices': json['logout_all_devices'] == null ? undefined : json['logout_all_devices'],
    };
}

export function PasswordChangeToJSON(json: any): PasswordChange {
    return PasswordChangeToJSONTyped(json, false);
}

export function PasswordChangeToJSONTyped(value?: PasswordChange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'old_password': value['old_password'],
        'new_password': value['new_password'],
        'logout_all_devices': value['logout_all_devices'],
    };
}

